/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navtitles_Resources1Inputs */

const en_navtitles_resources1 = /** @type {(inputs: Navtitles_Resources1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Navtitles_Resources1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const navtitles_resources1 = /** @type {((inputs?: Navtitles_Resources1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navtitles_Resources1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_navtitles_resources1(inputs)
});
export { navtitles_resources1 as "navTitles_resources" }